import script from "./DropdownRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__